import { jsxs, jsx } from "react/jsx-runtime";
const IconItalicSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M18 3H9a1 1 0 1 0 0 2h3.72l-3.5 14H6a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2h-3.72l3.5-14H18a1 1 0 1 0 0-2Z" })
    ]
  }
);
export {
  IconItalicSvg
};
